import fetch from 'isomorphic-fetch';
import { getUserContext } from 'selectors/user/userSelectors';
import handleZoomErrorNotifications from 'actions/helpers/handleZoomErrorNotifications';
import { getEntitiesRequest, getEntitiesResponse, editEntityRequest } from '../EntityActions';

export const editEvent = event => dispatch => {
  dispatch(editEntityRequest(event));
};

export function getRsvpPageEvents() {
  return (dispatch, getState) => {
    const state = getState();
    const userContext = getUserContext(state);
    const currentToasts = state.toasts;
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v2/cms/page/rsvp', {
      credentials: 'same-origin',
    })
      .then(response => response.json())
      .then(response =>
        handleZoomErrorNotifications({ dispatch, response, userContext, currentToasts })
      )
      .then(json => dispatch(getEntitiesResponse(json, 'events')));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/entities/RsvpActions.js